<template>
    <form @submit.prevent="createUser">
        <!-- Select de Clientes -->
        <div class="row">
            <div class="col-md-6">
                <label for="name" class="form-label">Nombre</label>
                <input type="text" id="name" class="form-control" v-model="selectedUser.name" required>
            </div>
            <div class="col-md-6">
                <label for="last-name" class="form-label">Apellido</label>
                <input type="text" id="last-name" class="form-control" v-model="selectedUser.last_name" required>
            </div>
        </div>
        <div class="mb-3 row">
            <div class="col-md-12">
                <label for="email" class="form-label">Correo</label>
                <input type="text" id="email" class="form-control" v-model="selectedUser.email" required>
            </div>
            <div class="col-md-12">
                <label for="personal-email" class="form-label">Correo Personal</label>
                <input type="email" id="personal-email" class="form-control" v-model="selectedUser.personal_email">
            </div>
        </div>
        <div class="mb-3 row">
            <div class="col-md-6">
                <label for="new-pass" class="form-label">Nueva Contraseña:</label>
                <input type="password" id="new-pass" class="form-control" placeholder="Nueva Contaseña" required>
            </div>
            <div class="col-md-6">
                <label for="confirm-new-pass" class="form-label">Confirma Contraseña:</label>
                <input type="password" id="confirm-new-pass" class="form-control" placeholder="Confirma Contaseña"
                    required>
            </div>
        </div>
        <div class="mb-3 row">
            <div class="col-md-6">
                <label for="teams" class="form-label">Equipo:</label>
                <select id="teams" v-model="selectedTeam" class="form-control" required>
                    <option disabled value="" selected>
                        Selecciona
                    </option>
                    <option v-for="team in teams" :key="team.team_id" :value="team.team_id">
                        {{ team.team }}
                    </option>
                </select>
            </div>
            <div class="col-md-6">
                <label for="user-type" class="form-label">Tipo de Usuario:</label>
                <select id="user-type" v-model="selectedUserType" class="form-control" required>
                    <option disabled value="" selected>
                        Selecciona
                    </option>
                    <option v-for="userType in userTypes" :key="userType.user_type_id" :value="userType.user_type_id">
                        {{ userType.user_type }}
                    </option>
                </select>
            </div>
            <div class="col-md-12">
                <label for="role" class="form-label">Puesto:</label>
                <input type="text" id="role" class="form-control" v-model="selectedUser.role" required>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <button type="submit" class="btn btn-warning w-100">Guardar</button>
            </div>
        </div>
    </form>
</template>

<script setup>

import { onMounted, ref } from 'vue';

import axios from 'axios';
const token = localStorage.getItem('authToken');
const API_BASE_URL = process.env.VUE_APP_BASE_URL;

const teams = ref([]);
const userTypes = ref([]);


const selectedUser = ref({}); // Usuario seleccionado para editar
const selectedTeam = ref(""); // Definir el valor inicial como una cadena vacía.
const selectedUserType = ref("");


// Función para obtener los datos de los equipos
const fetchTeamsData = async () => {
    try {
        const response = await axios.post(`${API_BASE_URL}/teams`, {}, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });
        teams.value = response.data; // Guardar los datos en teams
    } catch (error) {
        console.error('Error al obtener la información del usuario:', error);
    }
}

// Función para obtener los datos de los tipos de usuario
const fetchUserTypesData = async () => {
    try {
        const response = await axios.post(`${API_BASE_URL}/user-types`, {}, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });
        userTypes.value = response.data; // Guardar los datos en userTypes
    } catch (error) {
        console.error('Error al obtener la información del usuario:', error);
    }
}

const createUser = async () => {

    // Obtener valores de los campos de contraseña
    const newPassword = document.getElementById("new-pass")?.value || "";
    const confirmNewPassword = document.getElementById("confirm-new-pass")?.value || "";

    // Validar si se ingresó una nueva contraseña
    if ((newPassword || confirmNewPassword) && newPassword !== confirmNewPassword) {
        alert("Las contraseñas no coinciden");
        return;
    }

    // Construcción del objeto con los datos
    const userData = {
        name: selectedUser.value?.name || "",
        last_name: selectedUser.value?.last_name || "",
        email: selectedUser.value?.email || "",
        personal_email: selectedUser.value?.personal_email || "",
        team_id: selectedTeam.value || null,
        user_type_id: selectedUserType.value || null,
        role_title: selectedUser.value?.role || "",
    };

    // **Solo agregar la contraseña si se ingresó**
    if (newPassword && confirmNewPassword) {
        userData.password = newPassword;
    }
    try {
        const response = await axios.post(`${API_BASE_URL}/create-user`, userData, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });
        if (response.status === 200) {
            alert('Usuario Creado');
            window.location.reload();
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            alert(error.response.data.msg || 'Error desconocido');
        } else {
            alert('Ocurrió un error inesperado');
            console.error(error);
        }
    }
}

onMounted(async () => {
    fetchTeamsData();
    fetchUserTypesData();
})
</script>